const MAPEAMENTO_CAMPOS = {
    valor: 'Valor',
    data_fim: 'Data Fim',
    desconto: 'Desconto',
    frequencia: 'Frequência',
    vencimento: 'Vencimento',
    data_inicio: 'Data Início',
    desconto_tipo: 'Desconto Tipo'
};

/**
 * Formata uma data para exibicao no tooltip de historico.
 *
 * @param {string|null|undefined} dataStr
 * @returns {string|null}
 */
function formatarDataAlteracao(dataStr) {
    if (!dataStr) {
        return null;
    }

    const data = new Date(dataStr);
    data.setHours(data.getHours() + 3);
    return data.toLocaleDateString('pt-BR');
}

/**
 * Formata valor monetario para exibicao no tooltip de historico.
 *
 * @param {number|null|undefined} valor
 * @returns {string|null}
 */
function formatarMoedaAlteracao(valor) {
    return valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) ?? null;
}

/**
 * Resolve o nome amigavel de um campo para exibicao.
 *
 * @param {string} campo
 * @returns {string}
 */
function formatarCampoAlteracao(campo) {
    return MAPEAMENTO_CAMPOS[campo] || campo.charAt(0).toUpperCase() + campo.slice(1);
}

/**
 * Formata alteracoes de payload para exibicao no tooltip da listagem.
 *
 * @param {Record<string, any>|null} dadosAnteriores
 * @param {Record<string, any>|null} dadosNovos
 * @returns {string}
 */
export function formatarAlteracoes(dadosAnteriores, dadosNovos) {
    if (dadosAnteriores == null && dadosNovos == null) {
        return '';
    }

    const alteracoes = [];

    for (const campo of Object.keys(MAPEAMENTO_CAMPOS)) {
        let valorAnterior = dadosAnteriores?.[campo];
        let valorNovo = dadosNovos?.[campo];

        if (typeof valorAnterior === 'string') {
            valorAnterior = valorAnterior.toLowerCase();
        }
        if (typeof valorNovo === 'string') {
            valorNovo = valorNovo.toLowerCase();
        }

        if (campo.startsWith('data')) {
            valorAnterior = formatarDataAlteracao(valorAnterior);
            valorNovo = formatarDataAlteracao(valorNovo);
        } else if (campo === 'valor') {
            valorAnterior = formatarMoedaAlteracao(valorAnterior);
            valorNovo = formatarMoedaAlteracao(valorNovo);
        }

        if (valorAnterior === null && valorNovo !== null) {
            alteracoes.push(`${formatarCampoAlteracao(campo)} inserido: ${valorNovo}`);
        } else if (valorAnterior !== null && valorNovo === null) {
            alteracoes.push(`${formatarCampoAlteracao(campo)} removido (valor anterior era ${valorAnterior})`);
        } else if (valorAnterior !== valorNovo) {
            alteracoes.push(`${formatarCampoAlteracao(campo)} de ${valorAnterior} para ${valorNovo}`);
        }
    }

    return alteracoes.join('\n') || '';
}
